import React, { useCallback, useEffect, useRef } from 'react';
import css from './styles.module.scss';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getUserProfileData, selectNewDeal } from '~/features/dashboard/store/selectors';
import { KeyDateTypes } from '~/models/deals/new-deal/helpers';
import { Box, Typography, Grid, Button, Paper } from '@material-ui/core';
import { StepControls } from '~/common/step-controls';
import { createNewDealStepFiveThunk, getUserProfile } from '~/features/dashboard/store/actions.thunks';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { createSongTags, newDealFormNextStep } from '~/features/dashboard/store/actions';
import { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete/Autocomplete';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { pluck } from 'underscore';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment-timezone';
import { axiosInstance } from '~/api/config/axios.config';
import classNames from 'classnames';
import { TextFieldOutlined } from '~/common/text-field-outlined';
import { orderBy, find } from 'lodash';
import MomentUtilsNext from '@material-ui/pickers-next/adapter/moment';
import { DesktopDatePicker, LocalizationProvider } from '@material-ui/pickers-next';
import { Moment } from 'moment';
import { useDateFormat } from '~/common/date-format';
moment.tz.setDefault('GMT');
interface Step_5Props {
    prevStep: () => void;
}

export const Step_5: React.FC<Step_5Props> = ({ prevStep }) => {
    const { selectedDateFormat } = useDateFormat();
    const keyReasons = orderBy(
        [
            {
                label: 'Advance',
                value: KeyDateTypes.ADVANCE,
            },
            {
                label: 'Retention',
                value: KeyDateTypes.RETENTION,
            },
            {
                label: 'Audit',
                value: KeyDateTypes.AUDIT,
            },
            {
                label: 'Option',
                value: KeyDateTypes.OPTION,
            },
            {
                label: 'Other',
                value: KeyDateTypes.OTHER,
            },
            {
                label: 'Acquisition',
                value: KeyDateTypes.ACQUISITION,
            },
        ],
        [({ label }) => (label.toLowerCase() === 'other' ? 1 : 0), 'label'],
        ['asc']
    );
    let newDealState: any = useSelector(selectNewDeal);
    const dispatch = useThunkDispatch();
    const [currencyCodes, setCurrencyCodes] = React.useState<any>([]);
    const [defaultAcquasition, setDefaultAcquasition] = React.useState<any>([]);
    const [dealAcquisition, setDealAcquisition] = React.useState<{ Id: number; Text: string; value: string }[]>([]);
    let dealAdvance: any = ['USD'];
    const myRef = useRef<any>(null);

    if (currencyCodes) {
        dealAdvance = pluck(currencyCodes, 'code');
        dealAdvance = dealAdvance.filter(function (element: any) {
            return element !== undefined;
        });
    }
    let initialValues = {
        entryDate: null,
        contractType: String(KeyDateTypes.ADVANCE),
        contractNotes: '',
        contractNotesID: '',
        contractRefNum: '',
        contractNotesOther: '',
        contractNotesAmount: '',
        contractNotesCurrency: '',
        acquisition: [
            // {
            //     Id: 1,
            //     Text: 'PUBLISHER SHARE',
            //     value: 0,
            // },
        ],
        // acquisitionText: '',
        acquisitionID: 0,
    };

    const {
        register,
        control,
        handleSubmit,
        errors,
        setValue,
        watch,
        reset,
        formState: { isSubmitting },
        clearErrors,
        setError,
    } = useForm({
        mode: 'onBlur',
        defaultValues: {
            ...initialValues,
        },
    });
    const watchContractType = Number(watch('contractType'));
    let watchNotesAmount = watch('contractNotesAmount');
    let watchContractNotesCurrency = watch('contractNotesCurrency');
    let watchAcquisition = watch('acquisition');

    useEffect(() => {
        dispatch(getUserProfile());
    }, [dispatch]);

    const userProfileResponse = useSelector(getUserProfileData);
    useEffect(() => {
        if(userProfileResponse){
            if(userProfileResponse){
                setValue('contractNotesCurrency', userProfileResponse.currency);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfileResponse]);

    const onSubmit = useCallback(
        (data: any) => {
            // reset({data})

            dispatch(createNewDealStepFiveThunk({ ...data }));
            // setIsOther(false);
            setDefaultAcquasition([]);
            reset({
                ...initialValues,
            });
            dispatch(getUserProfile());
        },
        [dispatch] // eslint-disable-line
    );

    useEffect(() => {
        // TODO: use selector
        axiosInstance.get('Catalogue/projectReference/currencies/list').then(({data: { data }}) => {
            setCurrencyCodes(data);
        });

        axiosInstance.get('Catalogue/projectReference/acquisitiontype/list').then(async ({ data: rawData }: any) => {
            const data = orderBy(
                rawData.map((element: any) => ({
                    ...element,
                    value: 0,
                })),
                [({ Text }) => (Text.toLowerCase() === 'other' ? 1 : 0), 'Text'],
                ['asc']
            );

            await setDealAcquisition(data);
        });
    }, []);

    const editNewDealState = async (keyDate: any) => {
        let acquisitionTextList: any = [];
        keyDate.contractAcquisitionList?.forEach((el: any) => {
            let Obj = {
                Id: el.contractAcquisitionTypeId,
                value: el.contractAcquisitionID,
                Text: (dealAcquisition && dealAcquisition.find((item: any) => item.Id === el.contractAcquisitionTypeId)?.Text) || '',
            };
            acquisitionTextList.push(Obj);
        });

        setDefaultAcquasition(acquisitionTextList);

        setValue('contractType', String(keyDate.contractType));
        setValue('entryDate', keyDate.entryDate);
        setValue(`contractNotes`, keyDate.contractNotes);
        setValue('contractNotesAmount', keyDate.contractNotesAmount ? String(keyDate.contractNotesAmount) : '');
        setValue('contractNotesCurrency', keyDate.contractNotesCurrency);
        setValue('contractNotesID', keyDate.contractNotesID);
        setValue('acquisition', acquisitionTextList);

        let data = {
            gSongRef: '12sd',
        };
        dispatch(createSongTags.success(data));
        myRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    var removeByAttr = function (arr: any, attr: any, value: any) {
        var i = arr.length;
        while (i--) {
            if (arr[i] && arr[i].hasOwnProperty(attr) && arguments.length > 2 && arr[i][attr] === value) {
                arr.splice(i, 1);
            }
        }
        return arr;
    };
    useEffect(() => {
        setValue('contractNotesAmount', watchNotesAmount);
    }, [watchNotesAmount, setValue]);
    const deleteNewDealState = (contractNotesID: number) => {
        axiosInstance.delete(`/catalogue/projectCreator/keydates?contractNotesId=${contractNotesID}`);
        removeByAttr(newDealState.keyDates, 'contractNotesID', contractNotesID);
        let data = {
            gSongRef: '12sd',
        };
        dispatch(createSongTags.success(data));
    };

    useEffect(() => {
        let nonSelectedItems = defaultAcquasition.filter((obj: any) => watchAcquisition.every((s: any) => s.Id !== obj.Id));
        let data = [...defaultAcquasition];
        nonSelectedItems &&
            nonSelectedItems.length > 0 &&
            nonSelectedItems.forEach(async (element: any) => {
                await axiosInstance.delete('/catalogue/projectCreator/contractacquisition?ContractAcquisitionId=' + element.value);
                removeByAttr(data, 'Id', element.Id);
            });
        setDefaultAcquasition(data);
    }, [watchAcquisition]); // eslint-disable-line

    return (
        <Box className={css.module} {...{ref: myRef}} id="topScreen">
            <Box className={css.wrapper}>
                <Paper square elevation={0} className={classNames(css.paper, css.header)}>
                    <Typography align={'left'} variant={'h5'}>
                        {newDealState?.contractTitle}
                    </Typography>
                </Paper>
                <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                    <Box className={css.keyReasonsCheckBox} width="100%">
                        <Typography className={css.fieldName}>
                            Key Reason
                        </Typography>
                        <Controller
                            defaultValue={watchContractType || KeyDateTypes.ADVANCE}
                            render={props => (
                                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" width="100%">
                                    {keyReasons.map((item: any, index: any) => (
                                        <label key={index} className={css.keyReasonsCheckBox}>
                                            <input
                                                type="radio"
                                                // ref={register({ required: true })}
                                                value={item.value || watchContractType}
                                                checked={Number(props.value) === Number(item.value)}
                                                name={'contractType'}
                                                onChange={props.onChange}
                                            />
                                            <div className={'newdesign'}>
                                                <span>{item.label}</span>
                                            </div>
                                        </label>
                                    ))}
                                </Box>
                            )}
                            name={'contractType'}
                            control={control}
                        />
                    </Box>
                    <Grid container spacing={2} className={classNames(watchContractType !== KeyDateTypes.ADVANCE && css.hidden)}>
                        <Grid item xs={3}>
                            <TextFieldOutlined
                                name={`contractNotesAmount`}
                                label={'Amount'}
                                InputProps={{
                                    inputRef: register,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Controller
                                defaultValue={watchContractNotesCurrency}
                                render={props => (
                                    <Autocomplete
                                        {...props}
                                        options={dealAdvance}
                                        fullWidth
                                        defaultValue={watchContractNotesCurrency}
                                        value={props.value}
                                        renderInput={(p: AutocompleteRenderInputParams) => (
                                            <TextFieldOutlined {...p} label="Currency" />
                                        )}
                                        onChange={(_, data) => props.onChange(data)}
                                    />
                                )}
                                name={`contractNotesCurrency`}
                                control={control}
                            />
                        </Grid>
                    </Grid>
                    <Box className={classNames(watchContractType !== KeyDateTypes.ACQUISITION && css.hidden)} width="100%">
                        <Controller
                            defaultValue={watchAcquisition}
                            render={props => (
                                <Autocomplete
                                    {...props}
                                    multiple
                                    options={dealAcquisition}
                                    fullWidth
                                    getOptionSelected={(option: any, value: any) => option.Text === value.Text}
                                    getOptionLabel={(item: any) => item.Text}
                                    value={props.value}
                                    renderInput={(p: AutocompleteRenderInputParams) => (
                                        <TextFieldOutlined {...p} label="Types" />
                                    )}
                                    onChange={(_, data) => props.onChange(data)}
                                />
                            )}
                            name={`acquisition`}
                            control={control}
                        />
                    </Box>
                    <Grid container style={{ alignItems: 'center' }} spacing={2}>
                        <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={MomentUtilsNext}>
                                <div className={css.customdatepicker}>
                                    <Controller
                                        render={(controllerProps) => (
                                            <DesktopDatePicker
                                                onChange={newValue => {
                                                    clearErrors('entryDate');
                                                    if (!newValue) {
                                                        controllerProps.onChange(null);
                                                    } else if (newValue.isValid()) {
                                                        controllerProps.onChange((newValue as Moment).format("MM/DD/YYYY") || null);
                                                    } else {
                                                        setError('entryDate', { message: 'Invalid date' });
                                                    }
                                                }}
                                                value={controllerProps.value}
                                                inputFormat={selectedDateFormat}
                                                // inputFormat="MM/DD/YYYY"
                                                renderInput={(props: any) => (
                                                    <TextFieldOutlined
                                                        {...props}
                                                        error={!!errors?.entryDate}
                                                        helperText={(errors.entryDate?.message) || ' '}
                                                        label="Key Date"
                                                        name={'entryDate'}
                                                    />
                                                )}
                                            />
                                        )}
                                        name={'entryDate'}
                                        control={control}
                                        rules={{
                                            required: 'Required',
                                        }}
                                    />
                                </div>
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={7}>
                            <TextFieldOutlined
                                label={'Key Note'}
                                name={`contractNotes`}
                                InputProps={{
                                    inputRef: register({ required: 'Required' }),
                                }}
                                error={!!errors.contractNotes}
                                helperText={errors.contractNotes?.message}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button className={css.button} type="submit" disabled={isSubmitting}>
                                Add
                            </Button>
                        </Grid>
                    </Grid>
                    <div className={css.hidden}>
                        <input name="contractRefNum" ref={register} type="hidden" />
                        <input name="contractNotesID" ref={register} type="hidden" />
                    </div>
                    {newDealState && newDealState?.keyDates?.length > 0 && (
                        <table className={css.dataTable} cellPadding="0" cellSpacing="0">
                            <thead>
                                <tr>
                                    <td>Key Date</td>
                                    <td>Key Reason</td>
                                    <td>Amount</td>
                                    <td>Currency</td>
                                    <td>Acquisition Types</td>
                                    <td>Key Note</td>
                                    <td>
                                        <Box width="100%" textAlign="center">
                                            Actions
                                        </Box>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {orderBy(newDealState.keyDates, ['contractNotesID'], ['asc']).map((p: any) => (
                                    <tr key={p.contractNotesID}>
                                        <td>{moment(p.entryDate).format(selectedDateFormat)}</td>
                                        <td>{keyReasons.find(t => t.value === Number(p.contractType))?.label}</td>
                                        <td>{p.contractType === KeyDateTypes.ADVANCE && p.contractNotesAmount} </td>
                                        <td>{p.contractType === KeyDateTypes.ADVANCE && p.contractNotesCurrency} </td>
                                        <td>
                                            {p.contractType === KeyDateTypes.ACQUISITION && p.contractAcquisitionList && (
                                                <>
                                                    {p.contractAcquisitionList.map((contractAcquisition: any) => (
                                                        <Box key={contractAcquisition.contractAcquisitionTypeId}>
                                                            {find(dealAcquisition, ['Id', contractAcquisition.contractAcquisitionTypeId])?.Text}
                                                            <br />
                                                        </Box>
                                                    ))}
                                                </>
                                            )}
                                        </td>
                                        <td>{p.contractNotes} </td>
                                        <td>
                                            <Box width="100%" textAlign="center">
                                                <DeleteOutlineIcon titleAccess="Delete" className={css.deleteIcon} onClick={() => deleteNewDealState(p.contractNotesID)} />
                                                <EditIcon titleAccess="Edit" className={css.editIcon} onClick={() => editNewDealState(p)} />
                                            </Box>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                    <StepControls
                        onPrevClick={prevStep}
                        onNextClick={() => dispatch(newDealFormNextStep())}
                        errors={errors}
                    />
                </form>
            </Box>
        </Box>
    );
};
